import axios from "axios";

export const actions = {
  getSingleDeliveryUnitAccess(context, id) {
    return axios.get(`/Core/DeliverUnitAccess/${id}`);
  },
  addUsersDeliveryUnitAccess(context, data) {
    return axios.post(`/Core/DeliverUnitAccess/Add`, data);
  },
  removeDeliveryUnitAccess(context, id) {
    return axios.delete(`/Core/DeliverUnitAccess/Remove/${id}`);
  },
  getUsersDeliveryUnitAccess(context, applicationUserId) {
    return axios.get(`/Core/DeliverUnitAccess/ApplicationUser/${applicationUserId}`);
  },
};
